module.exports = __webpack_public_path__ + "static/img/xinhanfang_about.d2654d3a.png";